import marcusPic from "@/public/images/artists/marcus.png";
import { Artist } from "@/types/types";

export const marcus = {
  id: "192",
  name: "Marcus",
  image: marcusPic,
  description: `Marcus's voice sits in the rich, velvety pocket of a baritone, with a timbre that is warm, earthy, and effortlessly soulful. His delivery is laid-back and introspective, perfect for smooth R&B-style runs and the conversational phrasing of indie-folk.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fmarcus-preview.mp3",
  meta: {
    free: true,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Soul", "Indie", "Folk", "Unprocessed", "Airy", "Deep"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Bass",
        high: "Mid",
      },
      specific: {
        low: 41,
        high: 68,
      },
      sweetSpot: 58,
    },
  },
} as const satisfies Artist;
